import { create } from "zustand";

interface ISearchesState {
  searches: Record<string, unknown>;
  setSearches: <T>(key: string, data: T) => void;
  getSearches: <T>(key: string) => T | null | undefined;
}

export const useSearchesStore = create<ISearchesState>(
  (set, get) => ({
    searches: {},
    setSearches: <T>(key: string, data: T) => {
      set((state) => ({
        searches: { ...state.searches, [key]: data },
      }));
    },
    getSearches: <T>(key: string) => get().searches[key] as T | null | undefined,
  }),
);
